import { render, staticRenderFns } from "./BuildingOperation.vue?vue&type=template&id=0c43c124&scoped=true"
import script from "./BuildingOperation.vue?vue&type=script&lang=js"
export * from "./BuildingOperation.vue?vue&type=script&lang=js"
import style0 from "./BuildingOperation.vue?vue&type=style&index=0&id=0c43c124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43c124",
  null
  
)

export default component.exports